


























































import { POSPaymentTerminal } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
library.add(faPowerOff);

@Component({
  name: 'bpc-pos-terminal-selector',
  components: {},
})
export default class PosTerminalSelector extends Vue {
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Number }) readonly value: number;
  @Prop({ type: String }) readonly terminalType: string;
  @Prop({ type: Boolean, default: false })
  readonly checkTerminalStatus: boolean;

  terminals: POSPaymentTerminal[] = [];
  showNoTerminalsAlert = false;
  showNoTerminalsOnlineAlert = false;
  loadingTerminals = false;
  get model(): number {
    return this.value || null;
  }

  set model(value: number) {
    this.$emit('input', value);
  }

  mounted() {
    this.getTerminals();
  }

  // Method to retrieve available terminals
  async getTerminals() {
    this.loadingTerminals = true;
    const terminals = await this.$posService.getAvailableTerminals(
      this.posSessionId,
      this.terminalType,
    );
    this.terminals = terminals;
    if (this.terminals.length) {
      // Check if we need to select the first terminal with 'online' status
      if (this.checkTerminalStatus) {
        // Filter terminals with 'online' status
        const onlineTerminals = this.terminals.filter(
          terminal => terminal.externalStatus === 'Online',
        );

        // Check the number of 'online' terminals
        if (onlineTerminals.length === 1) {
          // If there's exactly one 'online' terminal, set its ID as the model
          this.model = onlineTerminals[0].id;
          this.showNoTerminalsOnlineAlert = false; // Reset the alert
        } else if (onlineTerminals.length === 0) {
          // If no 'online' terminals are available, reset the model and show the alert
          this.model = null;
          this.showNoTerminalsOnlineAlert = true;
        } else {
          // If more than one 'online' terminal is available, reset the model but don't select automatically
          this.model = null;
          this.showNoTerminalsOnlineAlert = false; // Reset the alert
        }
      } else {
        // Set the model to the ID of the first terminal in the array
        this.model = this.terminals?.[0].id || null;
      }
      if (this.terminals.length === 1) {
        this.$emit('only-one-terminal', this.model);
      }
    } else {
      // No terminals available, show the 'No terminals' alert
      this.model = null;
      this.showNoTerminalsAlert = true;
    }
    this.loadingTerminals = false;
  }

  // Method to determine if a terminal is disabled based on its 'externalStatus'
  disabledTerminal(terminalStatus): boolean {
    return terminalStatus !== 'Online';
  }
}
